import React, { useEffect, useState } from "react";
import CheckPartExtension from "./CheckPartExtension";
import DecisionMatrix from "./DecisionMatrix";
import SubstitutionPart from "./SubstitutionPart";
import PartInformation from "./PartInformation";
import { Typography, Paper, Box, Divider } from "@mui/material";
import { ReactComponent as Plant } from "../../assets/images/Plant.svg";
import Header from "../dashboard/Header";
import "../../styles/partCreation.css";
import { useNavigate, useLocation } from "react-router-dom";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import axios from "axios";
import PartDescription from "./PartDescription";
import PartCreationSuccess from "./PartCreationSuccess";
import PartExtension from "../dashboard/PartExtension";
import { automationHttpRequest } from "../../api/httpRequests";
import { ToastContainer, toast } from "react-toastify";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const PartCreation = () => {
  const navigate = useNavigate();
  const [checkPartData, setCheckPartData] = useState({});
  const [partInformationData, setPartInformationData] = useState({});
  const [decisionData, setDecisionData] = useState({
    impact_score: 0,
    probability_score: "",
    stock_decision: "",
    stock_decision_comment: "",
  });
  const [pirValue, setPirValue] = useState({});
  const [loading, setLoading] = useState(false);
  const [showDecision, setShowDecision] = useState(false);
  const [showPartInformation, setShowPartInformation] = useState(false);
  const [showSubstitution, setShowSubstitution] = useState(false);
  const [showInformation, setShowInformation] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [isUomValid, setIsUomValid] = useState(false);
  const [partDescriptionData, setPartDescriptionData] = useState({
    clean_short_description: "",
    modifier: "",
    noun_indentifier: "",
    material_group: "",
    attribute_data: "",
  });
  const [substitution_status, setSubstitution_status] = useState("no");
  const [extension, setExtension] = useState(false);
  const [equipment_number_for_bom, setEquipment_number_for_bom] = useState([]);
  const [partCreationDialog, setPartCreationDialog] = useState(false);
  const [requestID, setRequestID] = useState("");
  const [extensionData, setExtensionData] = useState({
    materialNumber: "",
    uid: "",
  });
  const [disableButton, setDisableButton] = useState(true);

  // useEffect(() => {
  //   setSearchString(localStorage.getItem("shortDesc"));
  // });

  // useEffect(() => {
  //   if (
  //     Object.keys(partInformationData).length >= 4 &&
  //     equipment_number_for_bom.length > 0
  //   ) {
  //     for (let key in partInformationData) {
  //       if (["critical_part", "storage_bin"].includes(key)) continue;
  //       if (!partInformationData[key] && partInformationData[key] !== 0) {
  //         return setDisableButton(true);
  //       }
  //     }
  //     setDisableButton(false);
  //   }
  // }, [partInformationData, equipment_number_for_bom]);

  useEffect(() => {
    let hasValue = false;
    for (let i = 0; i < equipment_number_for_bom.length; i++) {
      if (equipment_number_for_bom[i] !== "") {
        hasValue = true;
        break;
      }
    }
    if (
      partInformationData &&
      partInformationData.hasOwnProperty("maximum_stock_level") &&
      partInformationData.hasOwnProperty("minimum_stock_level") &&
      partInformationData.hasOwnProperty("ABC_indicator") &&
      partInformationData.hasOwnProperty("storage_location") &&
      hasValue &&
      partInformationData?.["maximum_stock_level"] > 0 &&
      partInformationData?.["ABC_indicator"]?.length > 0 &&
      partInformationData?.["storage_location"]?.length > 0 &&
      partInformationData?.["minimum_stock_level"] >= 0 &&
      partInformationData?.["minimum_stock_level"] <=
        partInformationData?.["maximum_stock_level"] &&
      partInformationData?.["minimum_stock_level"] !== "" &&
      partInformationData?.["maximum_stock_level"] !== ""
    ) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  }, [partInformationData, equipment_number_for_bom]);

  const handlePartCreationData = async () => {
    setLoading(true);
    try {
      if (!isUomValid) {
        toast.error("Some UOM values are missing or mismatched.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
        return;
      }
      const response = await automationHttpRequest.post(
        "/creation_insert/",
        {
          ...checkPartData,
          ...decisionData,
          ...pirValue,
          ...partInformationData,
          ...partDescriptionData,
          equipment_number_for_bom,
          substitution_status,
          plant_id: localStorage.getItem("MRO_user_plantId"),
          plant_name: localStorage.getItem("MRO_user_location"),
          submitted_by: localStorage.getItem("MRO_user_email"),
        },
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {},
        }
      );
      if (response?.data?.status) {
        setRequestID(response?.data?.data?.request_id);
        setPartCreationDialog(true);
        setLoading(false);
      } else {
        toast.error("Unable to process the request. Please try again!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      }
    } catch (error) {
      setLoading(false);
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 800,
      });
    }
  };

  const ButtonFamily = ({ btnText }) => {
    return (
      <>
        <button
          type="submit"
          className="submitButton"
          style={{
            fontSize: 16,
            position: "relative",
            fontFamily: "Verdana",
            cursor: disableButton ? "default" : "pointer",
            background: disableButton ? "#f5f5f5" : "#C6003D",
            color: disableButton ? "#C6003D" : "#FFFFFF",
          }}
          disabled={disableButton}
          onClick={(e) => {
            e.preventDefault();
            handlePartCreationData();
          }}
        >
          {loading && (
            <div
              className="loader"
              style={{ borderTop: "2px dotted white" }}
            ></div>
          )}
          {!loading && btnText}
        </button>

        <button
          type="submit"
          className="cancelButton"
          style={{
            fontSize: 16,
            cursor: "pointer",
            position: "relative",
            fontFamily: "Verdana",
          }}
          onClick={(e) => {
            e.preventDefault();
            navigate("/dashboard");
          }}
        >
          Cancel
        </button>
      </>
    );
  };

  const handleContinue = () => {
    setTimeout(() => {
      window.scrollBy({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    }, 500);
    setShowDecision(true);
  };

  const handleDecisionContinue = () => {
    setShowInformation(true);
    setTimeout(() => {
      window.scrollBy({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    }, 2500);
  };

  const handleInfoContinue = () => {
    setShowSubstitution(true);
    setTimeout(() => {
      window.scrollBy({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    }, 2000);
  };

  const disableInfoContinue = () => {
    setShowSubstitution(false);
    // setShowInformation(false);
    setShowPartInformation(false);
  };

  const handleSubstitutionContinue = () => {
    setShowPartInformation(true);
    setTimeout(() => {
      window.scrollBy({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    }, 2000);
  };
  const handleBackClick = () => {
    navigate("/dashboard");
  };
  const handleExtensionClose = () => {
    setExtension(false);
    setShowDecision(false);
    setShowSubstitution(false);
    setShowInformation(false);
    setShowPartInformation(false);
  };

  return (
    <>
      <Header />
      <div style={{ margin: "30px" }}>
        {extension ? (
          <>
            <PartExtension
              materialNumber={extensionData?.materialNumber}
              handleDialogClose={handleExtensionClose}
              uid={extensionData?.uid}
              handleBackClick={handleBackClick}
              callFromCreationScreen={true}
            />
          </>
        ) : (
          <>
            <div>
              <button
                style={{
                  display: "flex",
                  width: "90px",
                  justifyContent: "space-around",
                  alignItems: "center",
                  border: "0px",
                  background: "transparent",
                  margin: "0px 0px 20px 0px",
                  cursor: "pointer",
                }}
                onClick={() => handleBackClick()}
              >
                <ArrowBackIcon />
                <Typography> Back </Typography>
              </button>
            </div>
            <Typography
              sx={{
                color: "#2D3748",
                fontFamily: "Verdana",
                fontSize: "22px",
                fontWeight: "700",
                marginTop: "30px",
                marginBottom: "30px",
                width: "60%",
              }}
            >
              New Part Request
            </Typography>
            <Paper
              sx={{
                width: "25%",
                height: "100px",
                display: "flex",
              }}
              elevation={2}
            >
              <div className="plantCard">
                {/* <div>
                  <Plant />
                </div> */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Typography className="plantHead">
                    New Part Request for Plant
                  </Typography>
                  <Typography className="plantName">
                    {localStorage.getItem("MRO_user_location")}
                  </Typography>
                </div>
              </div>
            </Paper>
            <CheckPartExtension
              setCheckPartData={setCheckPartData}
              handleContinue={handleContinue}
              setExtension={setExtension}
              setExtensionData={setExtensionData}
              showDecision={showDecision}
            />
            {showDecision && (
              <DecisionMatrix
                setDecisionData={setDecisionData}
                handleContinue={handleDecisionContinue}
              />
            )}
            {showInformation && (
              <PartDescription
                handleContinue={handleInfoContinue}
                setSearchString={setSearchString}
                setPartDescriptionData={setPartDescriptionData}
                disableContinue={disableInfoContinue}
                onUomValidationChange={setIsUomValid}
              />
            )}
            {showSubstitution && (
              <SubstitutionPart
                setPirValue={setPirValue}
                handleContinue={handleSubstitutionContinue}
                searchString={searchString}
                setSubstitution_status={setSubstitution_status}
                checkPartData={checkPartData}
                setExtension={setExtension}
                setExtensionData={setExtensionData}
              />
            )}
            {showPartInformation && (
              <>
                <PartInformation
                  setPartInformationData={setPartInformationData}
                  setEquipment_number_for_bom={setEquipment_number_for_bom}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ButtonFamily btnText="Submit Part Request" />
                </div>
              </>
            )}
          </>
        )}
      </div>
      <PartCreationSuccess
        partCreationDialog={partCreationDialog}
        setPartCreationDialog={setPartCreationDialog}
        requestID={requestID}
      />
    </>
  );
};

export default PartCreation;
